import { Routes } from '@angular/router';
import {
  AppLayout,
  RoleGuard,
  AuthGuard,
  Roles,
  CaseAccessGuard,
  AccountAccessGuard,
} from 'shared-library';

export const routes: Routes = [
  {
    path: '',
    component: AppLayout,
    children: [
      {
        path: '',
        redirectTo: '/dashboard',
        pathMatch: 'full',
      },
      {
        path: 'dashboard',
        canActivate: [AuthGuard,RoleGuard],
         data: {
          role: [Roles.Administrator, Roles.Investigator,Roles.Guest],
        },
        loadComponent: () =>
          import('./pages/dashboard/dashboard.component').then(
            (m) => m.DashboardComponent
          ),
      },

      {
        path: 'case-table',
        canActivate: [AuthGuard, RoleGuard],
        data: {
          role: [Roles.Administrator, Roles.Adjuster, Roles.Guest, Roles.Investigator, Roles.Secretary],
        },
        loadComponent: () =>
          import('./pages/case-table/case-table.component').then(
            (m) => m.CaseTableComponent
          ),
      },

      {
        path: 'case-detail/:id',
        canActivate: [RoleGuard, AuthGuard, CaseAccessGuard],
        data: {
          role: [Roles.Administrator, Roles.Adjuster, Roles.Guest, Roles.Investigator, Roles.Secretary],
        },
        loadComponent: () =>
          import('./pages/case-detail/case-detail.component').then(
            (m) => m.CaseViewComponent
          ),
      },
      {
        path: 'reports',
        canActivate: [AuthGuard,RoleGuard],
         data: {
          role: [Roles.Administrator, Roles.Investigator, Roles.Guest],
        },
        loadChildren: () =>
          import('./routes/report-routes').then((m) => m.reportRoutes),
      },
      {
        path: 'nlp',
        canActivate: [AuthGuard,RoleGuard],
         data: {
          role: [Roles.Administrator, Roles.Investigator],
        },
        loadComponent: () =>
          import('./pages/reports/reports.component').then(
            (m) => m.ReportsComponent
          ),
      },
      {
        path: 'ysae-search',
        canActivate: [AuthGuard, RoleGuard],
        data: {
          role: [Roles.Administrator, Roles.Adjuster, Roles.CaseManager, Roles.Investigator, Roles.Guest],
        },
        loadComponent: () =>
          import('./pages/ysae-search/ysae-search.component').then(
            (m) => m.YsaeSearchComponent
          ),
      },
      {
        path: 'watch-list',
        canActivate: [AuthGuard, RoleGuard],
        data: {
          role: [Roles.Administrator, Roles.Investigator],
        },
        loadComponent: () =>
          import('./pages/watch-list/watch-list.component').then(
            (m) => m.WatchListComponent
          ),
      },
      {
        path: 'networkAnalysis',
        canActivate: [RoleGuard],
        data: { role: [Roles.Administrator, Roles.Investigator] },
        loadComponent: () =>
          import('./pages/network-analysis/network-analysis.component')
            .then(m => m.NetworkAnalysisComponent),
      },
      {
        path: 'manage-users',
        canActivate: [RoleGuard, AuthGuard],
        data: { role: Roles.Administrator },
        loadComponent: () =>
          import('shared-library').then((m) => m.ManageUsersComponent),
      },
      {
        path: 'create-user',
        resolve: [RoleGuard],
        canActivate: [AuthGuard],
        data: { role: Roles.Administrator },
        loadComponent: () =>
          import('shared-library').then((m) => m.AddUserComponent),
      },

      {
        path: 'user-details/:id',
        canActivate: [AuthGuard, AccountAccessGuard],
        loadComponent: () =>
          import('shared-library').then((m) => m.UserDetailsComponent),
      },
      {
        path: 'about-page',
        outlet: 'modal',
        loadComponent: () =>
          import('shared-library').then((m) => m.AboutPageComponent),
      },
    ],
  },
  {
    path: 'auth',
    loadChildren: () => import('shared-library').then((m) => m.AUTH_ROUTES),
  },
  {
    path: 'error',
    loadChildren: () => import('shared-library').then((m) => m.ERROR_ROUTES),
  },
  {
    path: '**',
    redirectTo: 'error/404',
  },
];
